import {
  LoginAccountDTO,
  StudentCreateRequest,
  StudentCreateWithPhoneCaptchaRequest,
  StudentCreateWithPhoneCaptchaAndTokenRequest
} from '../../../../gateway/BasicData-default'

export class WaitToRegisterAccount {
  /**
   * 手机号码
   */
  phoneNumber: string
  /**
   * 注册方式，11：平台注册，21：第三方互联之QQ，31：第三方互联之新浪微博，41：第三方互联之微信，42：第三方互联之 微信公众号，51：第三方互联之 外部来源
   */
  registerType: number

  /**
   * 注册来源，1：项目主网站，2：安卓，3：IOS 苹果
   */
  sourceType: number

  /**
   * 密码
   */
  password: string

  /**
   * 昵称必填，目前暂时和手机号一致
   */
  nickName: string
  /**
   * 注册的机构id
   */
  registerUnitId = '-1'
  /**
   * 工作单位
   */
  workUnitName: string
  /**
   * 工作单位地区路径
   */
  workUnitAreaPath: string

  toStudentCreateDTO(): StudentCreateRequest {
    const dto = new StudentCreateRequest()
    dto.phoneNumber = this.phoneNumber
    dto.registerType = this.registerType
    dto.sourceType = this.sourceType
    dto.uniqueType = -1
    dto.uniqueData = '-1'
    dto.sex = 4
    dto.nickName = this.nickName
    dto.workUnitName = this.workUnitName
    dto.workUnitAreaPath = this.workUnitAreaPath
    if (this.registerUnitId === undefined || this.registerUnitId === '') this.registerUnitId = '-1'
    dto.registerUnitId = this.registerUnitId
    dto.loginAccounts = new Array<LoginAccountDTO>()
    const loginAccount = new LoginAccountDTO()
    loginAccount.loginType = 3
    loginAccount.loginInput = this.phoneNumber
    loginAccount.password = this.password
    dto.loginAccounts.push(loginAccount)
    return dto
  }

  toStudentCreateWithPhoneCaptchaDTO(): StudentCreateWithPhoneCaptchaRequest {
    const dto = new StudentCreateWithPhoneCaptchaRequest()
    dto.registerType = this.registerType
    dto.sourceType = this.sourceType
    dto.uniqueType = -1
    dto.uniqueData = '-1'
    dto.sex = 4
    dto.nickName = this.nickName
    dto.password = this.password
    dto.workUnitName = this.workUnitName
    dto.workUnitAreaPath = this.workUnitAreaPath
    if (this.registerUnitId === undefined || this.registerUnitId === '') this.registerUnitId = '-1'
    dto.registerUnitId = this.registerUnitId
    return dto
  }

  toStudentCreateWithPhoneCaptchaAndTokenRequest(wxToken: string): StudentCreateWithPhoneCaptchaAndTokenRequest {
    const dto = new StudentCreateWithPhoneCaptchaAndTokenRequest()
    dto.registerType = this.registerType
    dto.sourceType = this.sourceType
    dto.uniqueType = -1
    dto.uniqueData = '-1'
    dto.sex = 4
    dto.nickName = this.nickName
    dto.password = this.password
    dto.token = wxToken
    dto.workUnitName = this.workUnitName
    dto.workUnitAreaPath = this.workUnitAreaPath
    return dto
  }
}
